import Plaatjie from '@ubo/plaatjie'
import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const Section = styled.section`
  padding-block: 6rem;
`

const Container = styled.div`
  position: relative;

  .background-image {
    position: absolute;
  }

  & h3 {
    color: #d50021;
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
  }

  p {
    text-align: justify;
    padding-right: 4.5rem;
  }

  @media (min-width: 992px) {
    top: 7.5%;
  }

  @media (max-width: 991.98px) {
    .background-image {
      max-height: 150px;
      right: 15%;
      top: -5rem;
    }

    .col-img-wrapper {
      order: -1;
    }

    .col-img {
      margin-top: 0.75rem;
      margin-bottom: 1.5rem;
    }
  }
`

function ContentImages({ image, items }) {
  return (
    <Section>
      <Container className="container pl-lg-5">
        <Plaatjie image={image} className="background-image" />
        {items.map((edge, index) => {
          const odd = index % 2 === 0

          return (
            <div className={`row ${odd ? 'pl-lg-5' : 'pr-lg-5'} mb-4 mb-lg-5`}>
              <div className="col-lg-7">
                <h2>{edge.title}</h2>
                <h3>{edge.subtitle}</h3>
                <ParseContent content={edge.description} />
              </div>
              <div className="col-img-wrapper col-lg-5">
                <Plaatjie image={edge.image} className="col-img" />
              </div>
            </div>
          )
        })}
      </Container>
    </Section>
  )
}

export default ContentImages
